import React, { useMemo, useState } from 'react';
import useUser from 'utils/useUser';
import { isAdmin, isRoleNameAdminTools } from 'utils/userTypeHelper';
import {
  UncontrolledDropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
} from 'reactstrap';
import PlusIcon from 'components/atoms/icons/plusIcon';
import BatchReportModal from './batchReportModal';
import SopReportModal from './sopReportModal';
import ResetInteractionStatus from './resetInteractionStatus';
import CsvButtonIcon from '../../atoms/icons/csvButtonIcon';

const CsvDropdown = () => {
  const [vitalCsvUploadOpen, setVitalCsvUploadOpen] = useState(false);
  const [sopCsvUploadOpen, setSopCsvUploadOpen] = useState(false);
  const [resetInteractionStatusOpen, setResetInteractionStatusOpen] =
    useState(false);
  const { userType, roleNames } = useUser();

  const iamAdminOrAdminTools = useMemo(
    () => isAdmin(userType) || isRoleNameAdminTools(roleNames),
    [userType, roleNames],
  );

  return (
    <>
      {iamAdminOrAdminTools && (
        <UncontrolledDropdown nav inNavbar>
          <DropdownToggle
            nav
            data-cy="add__toggle"
            className="navbar-dropdown-profile"
          >
            <CsvButtonIcon />
          </DropdownToggle>
          <DropdownMenu right className="navbar-dropdown profile-menu">
            {iamAdminOrAdminTools && (
              <DropdownItem
                data-cy="add__vital-report"
                className="navbar-dropdown-item"
                onClick={() => setVitalCsvUploadOpen(true)}
              >
                Batch Reports <PlusIcon />
              </DropdownItem>
            )}
            <DropdownItem
              data-cy="sop_check"
              className="navbar-dropdown-item"
              onClick={() => setSopCsvUploadOpen(true)}
            >
              Check For Existing Patients&nbsp;&nbsp; <PlusIcon />
            </DropdownItem>
            {iamAdminOrAdminTools && (
              <DropdownItem
                data-cy="reset_interaction_status"
                className="navbar-dropdown-item"
                onClick={() => setResetInteractionStatusOpen(true)}
              >
                Reset Interaction Status <PlusIcon />
              </DropdownItem>
            )}
          </DropdownMenu>
        </UncontrolledDropdown>
      )}
      {iamAdminOrAdminTools && (
        <BatchReportModal
          isOpen={vitalCsvUploadOpen}
          toggle={setVitalCsvUploadOpen}
        />
      )}
      <SopReportModal isOpen={sopCsvUploadOpen} toggle={setSopCsvUploadOpen} />
      <ResetInteractionStatus
        isOpen={resetInteractionStatusOpen}
        toggle={setResetInteractionStatusOpen}
      />
    </>
  );
};

export default CsvDropdown;
